import type { Category, CategoryNode, Task } from './types'

export function buildCategoryTree(categories: Category[]): CategoryNode[] {
  const active = categories.filter((category) => !category.deletedAt)
  const nodes = new Map(active.map((category) => [category.id, { ...category, children: [] as CategoryNode[] }]))
  const roots: CategoryNode[] = []

  for (const node of nodes.values()) {
    const parent = node.parentId ? nodes.get(node.parentId) : undefined
    if (parent && parent.id !== node.id) parent.children.push(node)
    else roots.push(node)
  }

  const sortNodes = (items: CategoryNode[]) => {
    items.sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name))
    items.forEach((item) => sortNodes(item.children))
  }
  sortNodes(roots)
  return roots
}

export function flattenCategories(nodes: CategoryNode[], depth = 0): Array<{ category: CategoryNode; depth: number }> {
  return nodes.flatMap((category) => [
    { category, depth },
    ...flattenCategories(category.children, depth + 1),
  ])
}

export function descendantIds(categoryId: string, categories: Category[]): string[] {
  const children = categories.filter((category) => category.parentId === categoryId && !category.deletedAt)
  return children.flatMap((child) => [child.id, ...descendantIds(child.id, categories)])
}

export function countOpenTasks(categoryId: string, categories: Category[], tasks: Task[]): number {
  const ids = new Set([categoryId, ...descendantIds(categoryId, categories)])
  return tasks.filter((task) => ids.has(task.categoryId) && !task.completed && !task.deletedAt).length
}

